// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".94d07f7427cf158fed722e8f60c3c52a1ab6d403.chunk.js";
};